export default __webpack_public_path__ + "static/media/pastel.dc3726c1.svg";